import { selectNext } from './select-next';
export var handleEnter = function (e, formOptions, activeStep, findCurrentStep, handleNext, handleSubmit) {
    if (e.key === 'Enter') {
        var isButtonOrTextarea = ['button', 'textarea'].includes(e.target.type);
        if (!isButtonOrTextarea) {
            e.preventDefault();
            var schemaNextStep = findCurrentStep(activeStep).nextStep;
            var hasCustomButtons = findCurrentStep(activeStep).buttons;
            var nextStep = void 0;
            if (schemaNextStep) {
                nextStep = selectNext(schemaNextStep, formOptions.getState);
            }
            var canContinue = formOptions.valid && !formOptions.getState().validating;
            if (canContinue && nextStep && !hasCustomButtons) {
                handleNext(nextStep, formOptions.getRegisteredFields);
            }
            else if (canContinue && !schemaNextStep && !hasCustomButtons) {
                handleSubmit();
            }
        }
    }
};
